import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {ActionService} from "@/services/action.service";
import {Logger} from "@/util/logger";
import {Subscription} from "rxjs";
import {Panorama} from "@/models/panorama";
import {PanoramaService} from "@/services/panorama.service";
import {ActionType} from "@/models/action.type";


@Component({
  standalone: false,
  selector:    'pano-navigator',
  template: `
    <div class="panorama-navigator-wrapper">

      <div *ngIf="next()"     (click)="navigateNext()"      class="panorama-navigator-next"></div>
      <div *ngIf="previous()" (click)="navigatePrevious()"  class="panorama-navigator-previous"></div>
      <div *ngIf="left()"     (click)="navigateLeft()"      class="panorama-navigator-left"></div>
      <div *ngIf="right()"    (click)="navigateRight()"     class="panorama-navigator-right"></div>
      <div                    (click)="navigateOverwatch()" class="panorama-navigator-return"></div>

    </div>`

})

/**
 *
 * @class PanoramaNavigator
 *
 * @brief brightness filter on top of the panoramic viewer
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      August 2022
 *
 */
export class PanoramaNavigator implements OnInit, OnDestroy, AfterViewInit {

  /** can we navigate to the left */
  public leftActive: boolean      = true;

  /** can we navigate to the right */
  public rightActive: boolean     = true;

  /** can we navigate forward */
  public nextActive: boolean      = true;

  /** can we navigate backwards */
  public previousActive: boolean  = true;

  /** our subscription to panorama changes */
  private _panoSubscription: Subscription         = null;

  /** the current panorama we are focused on */
  private _panorama: Panorama                     = null;

  /** standard constructor */
  constructor(
    private actions: ActionService,
    private panos:   PanoramaService
  ) {


  }

  /** what is the next panorama forward? */
  next(): Panorama|null {

    let pn: PanoramaNavigator  = this;

    if (!pn._panorama || !pn._panorama.next) {

      return null;
    }

    return pn._panorama.next;
  }

  /** what is the next panorama backward? */
  previous(): Panorama|null {

    let pn: PanoramaNavigator  = this;

    if (!pn._panorama || !pn._panorama.previous) {

      return null;
    }

    return pn._panorama.previous;
  }

  /** what is the next panorama to the left? */
  left(): Panorama|null {

    let pn: PanoramaNavigator  = this;

    if (!pn._panorama || !pn._panorama.left) {

      return null;
    }

    return pn._panorama.left;
  }

  /** what is the next panorama to the right? */
  right(): Panorama|null {

    let pn: PanoramaNavigator  = this;

    if (!pn._panorama || !pn._panorama.right) {

      return null;
    }

    return pn._panorama.right;
  }

  ngOnInit() {


  }

  ngOnDestroy() {

    let pn: PanoramaNavigator  = this;

    Logger.debug(`[PanoramaNavigator] ngOnDestroy ...`);

    pn._panoSubscription.unsubscribe();
  }

  ngAfterViewInit() {

    let pn: PanoramaNavigator  = this;

    pn._panoSubscription = pn.panos.onPanorama().subscribe(
      (meta: Panorama) => {

        if (pn._panorama && (pn._panorama.id == meta.id)) {

          Logger.debug(`[PanoramaNavigator] panorama change, but already set, ignoring.`);

          return ;
        }

        Logger.debug(`[PanoramaNavigator] panorama change...`);

        pn._panorama = meta;

      });
  }

  navigateLeft() {

    this.actions.action(ActionType.PANO_NAVIGATE_LEFT).execute();
  }

  navigateRight() {

    this.actions.action(ActionType.PANO_NAVIGATE_RIGHT).execute();
  }

  navigateNext() {

    this.actions.action(ActionType.PANO_NAVIGATE_NEXT).execute();
  }

  navigatePrevious() {

    this.actions.action(ActionType.PANO_NAVIGATE_PREVIOUS).execute();
  }

  navigateOverwatch() {

    this.actions.action(ActionType.PANO_NAVIGATE_BACK).execute();
  }

}
